import {Injectable} from '@angular/core';
import {BrowserStorageDataEnum} from '@services/browser-storage.service';
import {EquipmentCardPagingApiService} from '@api/equipment-card-paging.api.service';

@Injectable()
export class EquipmentPagesService extends EquipmentCardPagingApiService {
    itemsPerPageCounts = [25, 50, 100];

    defaultItemsPerPage = 25;

    itemsPerPageStorageKey = BrowserStorageDataEnum.equipmentStorageItemsPerPageCount;

    addFiltersToUrl = true;
}
